import React from 'react';
import { sameId } from './gameHelpers';

const ScoreBox = ({ players = [], judgeId }) => {
  if (players.length === 0) return null;
  return (
    <div className="scorebar" id="scores">
      {players.map((player) => (
        <span key={player.id} className="scorebar__item">
          {sameId(player.id, judgeId) && (
            <span className="scorebar__judge" title="Judge">⚖ </span>
          )}
          {player.name}{' '}
          <span className="scorebar__score">{player.score || 0}</span>
        </span>
      ))}
    </div>
  );
};

export default ScoreBox;
